(() => {
  if (window.__scrollRevealReady) return;
  window.__scrollRevealReady = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.dataset.revealReady || reduced.matches || !('IntersectionObserver' in window)) return;
    root.dataset.revealReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-reveal]'));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '100000px 0px -10% 0px', threshold: 0.1 }
    );

    items.forEach((item) => {
      if (item.getBoundingClientRect().top < window.innerHeight) {
        item.classList.add('is-revealed');
      } else {
        observer.observe(item);
      }
    });
    root.classList.add('js-reveal');
  };

  const initAll = () => document.querySelectorAll('[data-reveal-root]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
